import { useAtom } from "jotai"
import { FC } from "react"
import { MarkdownEditor } from "@duck/ui"
import { workspaceTaskAtom } from "@/store/workspaceAtoms"

export const AssignmentTab: FC = () => {
    const [task] = useAtom(workspaceTaskAtom)

    if (!task) {
        return null
    }

    return (
        <div className="p-4 lg:p-6 min-h-full">
            <MarkdownEditor
                defaultValue={task.body}
                className="max-w-none flex-1"
                mode="view"
                mdClassName="overflow-visible border-none p-0 pr-4"
            />
        </div>
    )
}
